"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = exports["default"] = {
  buttonContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    zIndex: 1
  },
  angleLabelContainer: {
    width: 120,
    height: 40,
    position: 'absolute',
    top: 0,
    left: 0
  },
  angleText: {
    display: 'flex',
    height: 'inherit',
    fontSize: '1.5rem'
  }
};